import { table } from "console";
import { URLTableMap } from "./types";
import packageJson from "../../package.json";

declare global {
  interface Window {
    gapi: any;
    google:any;
  }
}

export const APP_VERSION = packageJson.version;

export let emailCheck = "/emailCheck";
export let phoneNumberCheck = "/phoneNumberCheck";
export let sendOtp = "/sendOtp";
export let verifyOtp = "/verifyOtp";
export let saveUserOrganizationInfo = "/saveUserOrganizationInfo";
export let loginUrlCheck = "/loginUrlCheck";
export let login = "/zetranApp/login";
export let myPlanLogin = "/login";
export let myPlanOauthLogin = "/oauth/login";
export let forgotPassword = "/forgotPassword";
export let setPassword = "/setPassword";
export let loginUser = "/loginUser";
export let deleteUserAccount = "/deleteUserAccount";
export let accountActivation = "/accountActivation";
export let approveEstimate = "/approveEstimate";
export let approveSupportAccess = "/approveSupportAccess";
export let signInCheck = "/signInCheck";

export function remove_hash_from_url() {
  var uri = window.location.toString();

  if (uri.indexOf("#") > 0) {
    var clean_uri = uri.substring(0, uri.indexOf("#"));

    window.history.replaceState({}, document.title, clean_uri);
  }
}

export function generateRandomString(length:number) {
  var result = "";
  var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function isNumber(str:string) {
  var reg = new RegExp("^[0-9]+$");
  return reg.test(str);
}

export function validateEmail(email:string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function validatePassword(pw:string) {
  return (
    /[A-Z]/.test(pw) &&
    /[a-z]/.test(pw) &&
    /[0-9]/.test(pw) &&
    /[^A-Za-z0-9]/.test(pw) &&
    pw.length >= 8 &&
    pw.length <= 40
  );
}

export const CreateData = (obj: Record<string, any>): string => {
    const str: string[] = [];
    for (const p in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, p)) {
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
      }
    }
    return str.join("&");
  };

export let industryTypes = [
  { type: "Industries", industry_nm: "Agriculture and Farming" },
  { type: "Industries", industry_nm: "Art, Writing and Photography" },
  { type: "Industries", industry_nm: "Automotive" },
  { type: "Industries", industry_nm: "Construction and Services" },
  { type: "Industries", industry_nm: "Consultancy Services" },
  { type: "Industries", industry_nm: "Education and Services" },
  { type: "Industries", industry_nm: "Engineering, Design and Architecture" },
  { type: "Industries", industry_nm: "Entertainment" },
  { type: "Industries", industry_nm: "Financial Services" },
  { type: "Industries", industry_nm: "Food Services" },
  { type: "Industries", industry_nm: "Legal Services" },
  { type: "Industries", industry_nm: "Hospitality and Travel" },
  { type: "Industries", industry_nm: "Health Care" },
  { type: "Industries", industry_nm: "Manufacturing" },
  { type: "Industries", industry_nm: "Non-Profit" },
  { type: "Industries", industry_nm: "Publishing and Media" },
  { type: "Industries", industry_nm: "Real Estate" },
  { type: "Industries", industry_nm: "Retail" },
  { type: "Industries", industry_nm: "Sales Agency" },
  { type: "Industries", industry_nm: "Technology" },
  { type: "Industries", industry_nm: "Telecommunications" },
  { type: "Industries", industry_nm: "Transportation and Logistics" },
  { type: "Industries", industry_nm: "Generic Service Business" },
  { type: "Industries", industry_nm: "Generic Product Business" },
  { type: "Industries", industry_nm: "Trading" },
];



export let fiscalYearData = [
  {
    type: "Fiscal Year",
    fiscalYear_nm: "January-December",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "February-January",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "March-February",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "April-March",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "May-April",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "June-May",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "July-June",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "August-July",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "September-August",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "October-September",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "November-October",
  },
  {
    type: "Fiscal Year",
    fiscalYear_nm: "December-November",
  },
];

export const timeZoneList = [
  { name: "UTC", label: "(UTC) Coordinated Universal Time" },
  { name: "America/New_York", label: "(UTC-05:00) Eastern Time (US & Canada)" },
  { name: "America/Chicago", label: "(UTC-06:00) Central Time (US & Canada)" },
  { name: "America/Denver", label: "(UTC-07:00) Mountain Time (US & Canada)" },
  { name: "America/Los_Angeles", label: "(UTC-08:00) Pacific Time (US & Canada)" },
  { name: "America/Anchorage", label: "(UTC-09:00) Alaska Time" },
  { name: "Pacific/Honolulu", label: "(UTC-10:00) Hawaii-Aleutian Time" },
  { name: "America/Sao_Paulo", label: "(UTC-03:00) Brasília Time" },
  { name: "America/Argentina/Buenos_Aires", label: "(UTC-03:00) Argentina Time" },
  { name: "America/Mexico_City", label: "(UTC-06:00) Central Standard Time (Mexico)" },
  { name: "America/Toronto", label: "(UTC-05:00) Eastern Time (Canada)" },
  { name: "America/Santiago", label: "(UTC-03:00) Chile Time" },
  { name: "America/Bogota", label: "(UTC-05:00) Colombia Time" },
  { name: "America/Lima", label: "(UTC-05:00) Peru Time" },
  { name: "America/Caracas", label: "(UTC-04:00) Venezuela Time" },
  { name: "Europe/London", label: "(UTC+00:00) Greenwich Mean Time (GMT)" },
  { name: "Europe/Berlin", label: "(UTC+01:00) Central European Time (CET)" },
  { name: "Europe/Paris", label: "(UTC+01:00) Paris" },
  { name: "Europe/Rome", label: "(UTC+01:00) Central European Time (Rome)" },
  { name: "Europe/Madrid", label: "(UTC+01:00) Central European Time (Madrid)" },
  { name: "Europe/Amsterdam", label: "(UTC+01:00) Central European Time (Amsterdam)" },
  { name: "Europe/Brussels", label: "(UTC+01:00) Central European Time (Brussels)" },
  { name: "Europe/Vienna", label: "(UTC+01:00) Central European Time (Vienna)" },
  { name: "Europe/Warsaw", label: "(UTC+01:00) Central European Time (Warsaw)" },
  { name: "Europe/Prague", label: "(UTC+01:00) Central European Time (Prague)" },
  { name: "Europe/Budapest", label: "(UTC+01:00) Central European Time (Budapest)" },
  { name: "Europe/Bucharest", label: "(UTC+02:00) Eastern European Time (Bucharest)" },
  { name: "Europe/Athens", label: "(UTC+02:00) Eastern European Time (Athens)" },
  { name: "Europe/Helsinki", label: "(UTC+02:00) Eastern European Time (Helsinki)" },
  { name: "Europe/Istanbul", label: "(UTC+03:00) Turkey Time" },
  { name: "Europe/Moscow", label: "(UTC+03:00) Moscow Standard Time" },
  { name: "Europe/Kiev", label: "(UTC+02:00) Eastern European Time (Kiev)" },
  { name: "Europe/Minsk", label: "(UTC+03:00) Belarus Time" },
  { name: "Europe/Stockholm", label: "(UTC+01:00) Central European Time (Stockholm)" },
  { name: "Europe/Copenhagen", label: "(UTC+01:00) Central European Time (Copenhagen)" },
  { name: "Europe/Oslo", label: "(UTC+01:00) Central European Time (Oslo)" },
  { name: "Europe/Lisbon", label: "(UTC+00:00) Western European Time (Lisbon)" },
  { name: "Europe/Dublin", label: "(UTC+00:00) Irish Standard Time" },
  { name: "Europe/Zurich", label: "(UTC+01:00) Central European Time (Zurich)" },
  { name: "Africa/Cairo", label: "(UTC+02:00) Egypt Standard Time" },
  { name: "Africa/Johannesburg", label: "(UTC+02:00) South Africa Standard Time" },
  { name: "Africa/Lagos", label: "(UTC+01:00) West Africa Time" },
  { name: "Africa/Nairobi", label: "(UTC+03:00) East Africa Time" },
  { name: "Africa/Algiers", label: "(UTC+01:00) Central European Time (Algeria)" },
  { name: "Africa/Casablanca", label: "(UTC+01:00) Western European Time (Morocco)" },
  { name: "Africa/Tunis", label: "(UTC+01:00) Central European Time (Tunisia)" },
  { name: "Asia/Dubai", label: "(UTC+04:00) Gulf Standard Time" },
  { name: "Asia/Karachi", label: "(UTC+05:00) Pakistan Standard Time" },
  { name: "Indian/Maldives", label: "(UTC+05:00) Maldives Time" },
  { name: "Asia/Kolkata", label: "(UTC+05:30) India Standard Time" },
  { name: "Asia/Dhaka", label: "(UTC+06:00) Bangladesh Standard Time" },
  { name: "Asia/Kathmandu", label: "(UTC+05:45) Nepal Time" },
  { name: "Asia/Bangkok", label: "(UTC+07:00) Indochina Time" },
  { name: "Asia/Jakarta", label: "(UTC+07:00) Western Indonesia Time" },
  { name: "Asia/Shanghai", label: "(UTC+08:00) China Standard Time" },
  { name: "Asia/Hong_Kong", label: "(UTC+08:00) Hong Kong Time" },
  { name: "Asia/Singapore", label: "(UTC+08:00) Singapore Time" },
  { name: "Asia/Manila", label: "(UTC+08:00) Philippine Time" },
  { name: "Asia/Kuala_Lumpur", label: "(UTC+08:00) Malaysia Time" },
  { name: "Asia/Taipei", label: "(UTC+08:00) Taipei Time" },
  { name: "Asia/Tokyo", label: "(UTC+09:00) Japan Standard Time" },
  { name: "Asia/Seoul", label: "(UTC+09:00) Korea Standard Time" },
  { name: "Asia/Kabul", label: "(UTC+04:30) Afghanistan Time" },
  { name: "Asia/Tehran", label: "(UTC+03:30) Iran Standard Time" },
  { name: "Asia/Baghdad", label: "(UTC+03:00) Arabia Standard Time (Iraq)" },
  { name: "Asia/Riyadh", label: "(UTC+03:00) Arabia Standard Time" },
  { name: "Asia/Jerusalem", label: "(UTC+02:00) Israel Time" },
  { name: "Asia/Beirut", label: "(UTC+02:00) Eastern European Time (Beirut)" },
  { name: "Asia/Amman", label: "(UTC+02:00) Eastern European Time (Jordan)" },
  { name: "Asia/Kuwait", label: "(UTC+03:00) Arabia Standard Time (Kuwait)" },
  { name: "Asia/Baku", label: "(UTC+04:00) Azerbaijan Time" },
  { name: "Asia/Yerevan", label: "(UTC+04:00) Armenia Time" },
  { name: "Asia/Tbilisi", label: "(UTC+04:00) Georgia Time" },
  { name: "Asia/Tashkent", label: "(UTC+05:00) Uzbekistan Time" },
  { name: "Asia/Almaty", label: "(UTC+06:00) Kazakhstan Time" },
  { name: "Asia/Bishkek", label: "(UTC+06:00) Kyrgyzstan Time" },
  { name: "Asia/Yangon", label: "(UTC+06:30) Myanmar Time" },
  { name: "Asia/Ho_Chi_Minh", label: "(UTC+07:00) Indochina Time (Vietnam)" },
  { name: "Asia/Phnom_Penh", label: "(UTC+07:00) Indochina Time (Cambodia)" },
  { name: "Asia/Vientiane", label: "(UTC+07:00) Indochina Time (Laos)" },
  { name: "Asia/Colombo", label: "(UTC+05:30) Sri Lanka Time" },
  { name: "Asia/Thimphu", label: "(UTC+06:00) Bhutan Time" },
  { name: "Asia/Ulaanbaatar", label: "(UTC+08:00) Ulaanbaatar Time" },
  { name: "Asia/Pyongyang", label: "(UTC+09:00) Pyongyang Time" },
  { name: "Asia/Dili", label: "(UTC+09:00) Timor-Leste Time" },
  { name: "Australia/Sydney", label: "(UTC+10:00) Australian Eastern Time" },
  { name: "Australia/Melbourne", label: "(UTC+10:00) Australian Eastern Time (Melbourne)" },
  { name: "Australia/Brisbane", label: "(UTC+10:00) Australian Eastern Standard Time" },
  { name: "Australia/Perth", label: "(UTC+08:00) Australian Western Standard Time" },
  { name: "Australia/Adelaide", label: "(UTC+09:30) Australian Central Time" },
  { name: "Pacific/Auckland", label: "(UTC+12:00) New Zealand Standard Time" },
  { name: "Pacific/Fiji", label: "(UTC+12:00) Fiji Time" },
  { name: "Pacific/Port_Moresby", label: "(UTC+10:00) Papua New Guinea Time" },
  { name: "Pacific/Guam", label: "(UTC+10:00) Chamorro Standard Time" },
  { name: "Pacific/Pago_Pago", label: "(UTC-11:00) Samoa Standard Time" },
  { name: "Pacific/Tongatapu", label: "(UTC+13:00) Tonga Time" },
  { name: "Pacific/Apia", label: "(UTC+13:00) Apia Time" },
  { name: "Pacific/Tarawa", label: "(UTC+12:00) Gilbert Islands Time" },
  { name: "Pacific/Majuro", label: "(UTC+12:00) Marshall Islands Time" },
  { name: "Pacific/Palau", label: "(UTC+09:00) Palau Time" },
  { name: "Pacific/Nauru", label: "(UTC+12:00) Nauru Time" },
  { name: "Pacific/Funafuti", label: "(UTC+12:00) Tuvalu Time" },
  { name: "Pacific/Efate", label: "(UTC+11:00) Vanuatu Time" },
  { name: "Pacific/Guadalcanal", label: "(UTC+11:00) Solomon Islands Time" },
  { name: "America/Panama", label: "(UTC-05:00) Eastern Standard Time (Panama)" },
  { name: "America/Costa_Rica", label: "(UTC-06:00) Central Standard Time (Costa Rica)" },
  { name: "America/Guatemala", label: "(UTC-06:00) Central Standard Time (Guatemala)" },
  { name: "America/Tegucigalpa", label: "(UTC-06:00) Central Standard Time (Honduras)" },
  { name: "America/Managua", label: "(UTC-06:00) Central Standard Time (Nicaragua)" },
  { name: "America/El_Salvador", label: "(UTC-06:00) Central Standard Time (El Salvador)" },
  { name: "America/Belize", label: "(UTC-06:00) Central Standard Time (Belize)" },
  { name: "America/Jamaica", label: "(UTC-05:00) Eastern Standard Time (Jamaica)" },
  { name: "America/Havana", label: "(UTC-05:00) Cuba Standard Time" },
  { name: "America/Port-au-Prince", label: "(UTC-05:00) Eastern Standard Time (Haiti)" },
  { name: "America/Santo_Domingo", label: "(UTC-04:00) Atlantic Standard Time (Dominican Republic)" },
  { name: "America/La_Paz", label: "(UTC-04:00) Bolivia Time" },
  { name: "America/Asuncion", label: "(UTC-04:00) Paraguay Time" },
  { name: "America/Montevideo", label: "(UTC-03:00) Uruguay Time" },
  { name: "America/Guyana", label: "(UTC-04:00) Guyana Time" },
  { name: "America/Paramaribo", label: "(UTC-03:00) Suriname Time" },
  { name: "America/Cayenne", label: "(UTC-03:00) French Guiana Time" },
  { name: "Atlantic/Reykjavik", label: "(UTC+00:00) Iceland Time" },
  { name: "America/Barbados", label: "(UTC-04:00) Atlantic Standard Time (Barbados)" },
  { name: "America/Port_of_Spain", label: "(UTC-04:00) Atlantic Standard Time (Trinidad)" },
  { name: "America/St_Johns", label: "(UTC-03:30) Newfoundland Standard Time" }
]


export const fiscalYearList = [
  { id: "FY-US-Federal", name: "Federal Government Fiscal Year", description: "1st October to 30th September", start: "01/10", end: "30/09" },
  { id: "FY-US-Personal", name: "Personal Tax Fiscal Year", description: "1st January to 31st December", start: "01/01", end: "31/12" },
  { id: "FY-Standard-April-March", name: "April to March Fiscal Year", description: "1st April to 31st March", start: "01/04", end: "31/03" },
  { id: "FY-Standard-July-June", name: "July to June Fiscal Year", description: "1st July to 30th June", start: "01/07", end: "30/06" },
  { id: "FY-UK-Personal", name: "UK Personal Tax Year", description: "6th April to 5th April", start: "06/04", end: "05/04" },
  { id: "FY-March-March", name: "March to March Fiscal Year", description: "21st March to 20th March", start: "21/03", end: "20/03" },
  { id: "FY-July-July", name: "July to July Fiscal Year", description: "8th July to 7th July", start: "08/07", end: "07/07" },
  { id: "FY-Oct-Sept", name: "October to September Fiscal Year", description: "1st October to 30th September", start: "01/10", end: "30/09" },
  { id: "FY-January-December", name: "Calendar Year Fiscal Year", description: "1st January to 31st December", start: "01/01", end: "31/12" },
  { id: "FY-July-June", name: "July to June Fiscal Year", description: "1st July to 30th June", start: "01/07", end: "30/06" },
  { id: "FY-April-March", name: "April to March Fiscal Year", description: "1st April to 31st March", start: "01/04", end: "31/03" },
  { id: "FY-July-July-Alt", name: "July to July(Nepal)", description: "16th July to 15th July", start: "16/07", end: "15/07" },
  { id: "FY-August-July", name: "August to July Fiscal Year", description: "1st August to 31st July", start: "01/08", end: "31/07" }
];

export const getFiscalYearConfig = (fiscalYearId: string) => {
    return fiscalYearList.find(fy => fy.id === fiscalYearId);
};

export enum APIEndpoints {
  GET_CONTACTS = '/masterdata/getContacts',
  GET_ITEMS = '/masterdata/getItems',
  GET_BIZMASTER ='/appservice/getBizMaster',
  GET_BIZLIST_FOR_USER ='/appservice/getBizListForUser',
  GET_FIELDCONFIG ='/appservice/getFieldConfig',
  GET_ACCOUNTS ='/masterdata/getAccounts',
  GET_TAXES ='/masterdata/getTaxes',
  GET_ZATTRIBUTES ='/masterdata/getZAttributes',
  GET_PAYMENTTERMS ='/masterdata/getPaymentTerms',
  GET_BIZSETTINGS ='/masterdata/getBizSettings',
  GET_LEDGERS ='/ledger/getLedgers',
  GET_BANKDETAILS = '/banking/getBankDetails',
  GET_UOMS = '/masterdata/getUoms',
  GET_TABLECONFIG = '/appservice/getTableConfig',
  GET_USERACCESSROLE = '/auth/userAccessRole',
  GET_REPORTINGDASHBOARD = '/reporting/getDashboard',
  GET_PRICELISTS = '/masterdata/getPriceLists',
  BULK_DELETE_TXN = '/txndata/bulkDeleteTxn',
  BULK_DELETE_PAYMENT = '/txndata/bulkDeletePayment',
  BULK_DELETE_LEDGER = '/ledger/bulkDeleteLedger',
  GET_REC_TXNS_ALL = '/txndata/getRecTxnsAll',
  GET_TXNS = '/txndata/getTxns',
  GET_TXNS_WITH_FILTERS = '/txndata/getTxnsWithFilters',
  GET_ITEM_ANALYTICS= '/inventory/getItemAnalytics',
  GET_BANKTXNS = '/banking/bankTransactions',
  GET_BANK_SUGGESTIONS = '/banking/suggestions',
  GET_UNMATCHED_LEDGER = '/banking/unmatched-ledger',
  GET_LEDGER_ENTRIES_WITH_BALANCE = '/reporting/ledger-entries-with-balance',
}

export const PageWidths = [
  // Thermal Layout (width in inches converted to pixels at 96 DPI)
  { label: "2 inch", value: "192", variant: "thermal" },
  { label: "3 inch", value: "288", variant: "thermal" },
  { label: "4 inch", value: "384", variant: "thermal" }, 
  { label: "5 inch", value: "480", variant: "thermal" },

  // Regular Layout (Common page sizes in pixels at 96 DPI)
  { label: "A4", value: "794", variant: "regular" },      
  { label: "Letter", value: "816", variant: "regular" },  
  { label: "Legal", value: "960", variant: "regular" },   
  { label: "A5", value: "559", variant: "regular" }      
];

export const URLTableMapping: URLTableMap[] = [
  { url: APIEndpoints.GET_CONTACTS, tables: ['contacts','txns','payments'] },
  { url: APIEndpoints.GET_ITEMS, tables: ['items','txns'] },
  { url: APIEndpoints.GET_BIZMASTER, tables: ['bizmasters'] },
  { url: APIEndpoints.GET_BIZLIST_FOR_USER, tables: ['bizmasters'] },
  { url: APIEndpoints.GET_FIELDCONFIG, tables: ['fieldconfigs'] },
  { url: APIEndpoints.GET_TABLECONFIG, tables: ['tableconfigs', 'fieldconfigs'] },
  { url: APIEndpoints.GET_ACCOUNTS, tables: ['accounts'] },
  { url: APIEndpoints.GET_TAXES, tables: ['taxes'] },
  { url: APIEndpoints.GET_UOMS, tables: ['uoms'] },
  { url: APIEndpoints.GET_ZATTRIBUTES, tables: ['zattributes'] },
  { url: APIEndpoints.GET_PAYMENTTERMS, tables: ['paymentterms'] },
  { url: APIEndpoints.GET_BIZSETTINGS, tables: ['bizsettings'] },
  { url: APIEndpoints.GET_USERACCESSROLE, tables: ['bizmasters'] },
  { url: APIEndpoints.GET_PRICELISTS, tables: ['pricelists'] },
  { url: APIEndpoints.GET_REPORTINGDASHBOARD, tables: ['txns','ledgers','payments','banktransactions'] },
  { url: APIEndpoints.GET_BANKDETAILS, tables: ['accounts', 'txns','ledgers','payments','banktransactions'] },
  { url: APIEndpoints.GET_BANKTXNS, tables: ['ledgers','txns','payments','banktransactions'] },
  // Pending-line suggestions (auto-match + rules) and the unmatched myBooksAi entries derive from the same
  // tables as the bank list, so they refresh exactly when it would. Rule edits aren't a tracked table —
  // api.ts forgets these lists' refresh time when a rule changes.
  { url: APIEndpoints.GET_BANK_SUGGESTIONS, tables: ['ledgers','txns','payments','banktransactions'] },
  { url: APIEndpoints.GET_UNMATCHED_LEDGER, tables: ['ledgers','txns','payments','banktransactions'] },
  { url: APIEndpoints.GET_LEDGER_ENTRIES_WITH_BALANCE, tables: ['ledgers','txns','payments'] },
  // Txn lists are cached per filter combination — fetchData's cache key includes the path + sorted query params
  { url: APIEndpoints.GET_TXNS, tables: ['txns','payments','contacts'] },
  { url: APIEndpoints.GET_TXNS_WITH_FILTERS, tables: ['txns','payments','contacts'] },
];

export enum AccountType {
  Assets = "Assets",
  Liabilities = "Liabilities",
  Equity = "Equity",
  Income = "Income",
  Expense = "Expense",
  OtherIncome = "OtherIncome",
  OtherExpense = "OtherExpense"
}

export enum AccountCategory {
  Cash = "Cash",
  Bank = "Bank",
  CurrentAssets = "CurrentAssets",
  OtherCurrentAssets = "OtherCurrentAssets",
  LongTermAssets = "LongTermAssets",
  CreditCard = "CreditCard",
  CurrentLiabilities = "CurrentLiabilities",
  OtherCurrentLiabilities = "OtherCurrentLiabilities",
  Income = "Income",
  CostOfGoodsSold = "CostOfGoodsSold",
  OperatingExpense = "OperatingExpense",
  Equity = "Equity",
  OtherIncome = "OtherIncome",
  OtherExpense = "OtherExpense"
}







